<template>
  <div>
    <Fieldset :legend="toUpperCase(translate('experience', 'ucfirst'))"
      class="relative w-full px-5 py-2 mt-5 bg-white rounded-lg shadow-md border border-color-iron">
      <Skeleton v-if="isLoading && listExperiences" height="1.5rem" class="mb-2"></Skeleton>
      <span v-else-if="!isLoading && JSON.stringify(listExperiences) != '[]'" class="w-full">
        <article v-for="(experience, index) in listExperiences" :key="index" class="relative mt-6 mb-6">
          <div class="mb-2">
            <h1 class="uppercase text-oxford-blue">
              <b class="font-bold">{{ translate('job title', 'ucfirst')  }}: </b>{{ experience.job_title }}
            </h1>
            <h3 class=" uppercase text-sm text-oxford-blue">
                <b class="font-bold">{{ translate('company name', 'ucfirst')  }}: </b> {{ translate(experience.company_name, 'ucfirst') }}
            </h3>
            <span>
              <b class="uppercase font-bold">{{ translate('period', 'ucfirst')  }}: </b>
              <small>{{ dateFormatedFull(experience.start_date) }}</small> - 
              <small>
                {{ 
                  experience.end_date.slice(0, 10) !== '9999-12-31' ? 
                    dateFormatedFull(experience.end_date) : 
                        translate('currently working', 'ucfirst')
                }}
              </small>
            </span>
          </div>
          <p class="mr-2 pr-3 w-4/5 text-wrap">{{ experience.description.slice(0, 250) }}{{ experience.description.length > 250 ? '...' : '' }}</p>
          <i @click="showModal('update','experience',experience)" class="pi pi-pencil cursor-pointer absolute top-10 right-2 text-lg"></i>
          <hr class="mt-4 border-t border-iron">
        </article>
        <i @click="showModal('create','experience')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
      </span>
      <span v-else class="w-full pt-5 pb-7">
        <p class="font-medium">{{ translate('no experience', 'ucfirst') }}</p>
        <i @click="showModal('create','experience')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
      </span>
    </Fieldset>

    <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
      <template #title>
        <span class="uppercase">{{ displayModalTitle }}</span>
      </template>
      <template #content>
        <ProfessionalExperienceForm :experiencetoUpdate="experienceUpdate" @close-modal="closeModalDialog" @update-experiencies="updateExperiencies" 
        :curriculum-id="props.experiences.curriculum.id" />
      </template>
    </ModalDialogComponent>

  </div>
</template>

<script setup>
import { ref, onMounted, onUpdated } from 'vue'
import Fieldset from "primevue/fieldset";
import Skeleton from 'primevue/skeleton';
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalExperienceForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalExperienceForm.vue";
import { toUpperCase } from '@/composables/textUtils';

const props = defineProps({
  experiences: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let isLoading = ref(false)
let listExperiences = ref([])
let visible = ref(false)  
let experienceUpdate = ref({})  
let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum()


// ############ Criação de Métodos/Funções ############

const dateFormatedFull = ((date) => {
  return new Date(date).toLocaleDateString(navigator.language);
})

function showModal(type, title, experience={}) {
  toggleCreateUpdateTitle(type,title)
  experienceUpdate.value = experience
  visible.value = true
}

function closeModalDialog(event){  
  visible.value = event
}

async function updateExperiencies() {
 
  isLoading.value = true
  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) listExperiences.value = response.data.experiences;
  
  isLoading.value = false
}

onUpdated(() => { 
  isLoading.value = false
  if (props.experiences.experiences.length > 0){
    listExperiences.value = props.experiences.experiences
  }
})

onMounted(() => {
  isLoading.value = true
});
</script>